import axios from "axios";
import { decryptFromStoreLoc } from "../helper/localStorage";


export const apiClient = axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}/`,
    headers: {
        "Content-Type": "application/json",
    },
    // timeout: 120000,
});


apiClient.interceptors.request.use(
    function (config) {
        const token = decryptFromStoreLoc("token");
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);


export const loginAdmin = (data) => {
    return apiClient.post("admin/login", data);
};


export const forgotPassword = (data) => {
    return apiClient.post("admin/forgot/password", data);
}


export const verifyOtp = (data) => {
    return apiClient.post("admin/verify/forgot/otp", data);
}


export const resetPassword = (data) => {
    return apiClient.post("admin/password/change", data,);
}

export const updateProfile = (data) => {
    return apiClient.post("admin/profile", data, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
}

export const getAllUser = (limit, page, search, role, deviceType) => {
    let url = `admin/list?page=${page}&limit=${limit}&search=${search}`;
    if (role) {
        url += `&role=${role}`;
    }
    if (deviceType) {
        url += `&deviceType=${deviceType}`;
    }
    return apiClient.get(url);
}


export const getUser = (userId) => {
    return apiClient.get(`admin/all/user/${userId}`);
}
export const editUser = (data, id) => {
    // FormData (new profile photo) is sent as multipart, anything else as JSON
    const config = data instanceof FormData ? { headers: { "Content-Type": "multipart/form-data" } } : undefined;
    return apiClient.patch(`admin/user/${id}`, data, config);
}

export const deleteUser = (id) => {
    return apiClient.delete(`admin/user/${id}`);
}

export const exportUser = (search, role, deviceType) => {
    let url = `admin/export-user-list?search=${search}`;
    if (role) {
        url += `&role=${role}`;
    }
    if (deviceType) {
        url += `&deviceType=${deviceType}`;
    }
    return apiClient.get(url);
}

export const getDashboard = (params = 'today') => {
    let queryString = '';
    
    if (typeof params === 'object' && params.period === 'custom') {
        // Custom range parameters
        queryString = `period=${params.period}&startDate=${params.startDate}&endDate=${params.endDate}`;
    } else if (typeof params === 'object' && params.chartPeriod) {
        // Chart period parameter
        queryString = `chartPeriod=${params.chartPeriod}`;
    } else {
        // Regular period parameter
        queryString = `period=${params}`;
    }
    
    return apiClient.get(`admin/dashboard?${queryString}`);
}

export const getAllActivity = (limit, page, search) => {
    return apiClient.get(`admin/activity/list?page=${page}&limit=${limit}&search=${search}`);
}

export const editActivity = (data, activityId) => {
    return apiClient.post(`admin/activity/status/${activityId}`, data);
}

export const getAlLComment = (limit, page, search) => {
    return apiClient.get(`admin/comment/list?page=${page}&limit=${limit}&search=${search}`);
}

export const getAlLReplyComment = (limit, page, search) => {
    return apiClient.get(`admin/replyComment/list?page=${page}&limit=${limit}&search=${search}`);
}

export const deleteFlaggedActivity = (activityId) => {
    return apiClient.delete(`admin/flagged-activity/${activityId}`);
}

export const getReportedPendingCount = () => {
    return apiClient.get('admin/reported/pending-count');
}

// Tells the sidebar badge to recount (call after an admin action on reported content)
export const refreshReportedCount = () => window.dispatchEvent(new Event('reported-count-refresh'));

export const getActivityImages =(limit, page, search) => {
    return apiClient.get(`admin/activity-images?page=${page}&limit=${limit}&search=${encodeURIComponent(search || "")}`);
}

export const getReportedStories = (limit, page) => {
    return apiClient.get(`admin/story/reported/list?page=${page}&limit=${limit}`);
}

export const editStory = (data, storyId) => {
    return apiClient.post(`admin/story/status/${storyId}`, data);
}

export const deleteReportedStory = (storyId) => {
    return apiClient.delete(`admin/story/reported/${storyId}`);
}

// AO 2.0 (D4): reported Crew Board threads / replies. type = "thread" | "reply"
export const getReportedBoardItems = (type, limit, page) => {
    return apiClient.get(`admin/board/reported/list?type=${type}&page=${page}&limit=${limit}`);
}

export const editBoardItem = (data, type, id) => {
    return apiClient.post(`admin/board/reported/${type}/${id}/status`, data);
}

export const deleteReportedBoardItem = (type, id) => {
    return apiClient.delete(`admin/board/reported/${type}/${id}`);
}

export const dismissBoardReports = (type, id) => {
    return apiClient.post(`admin/board/reported/${type}/${id}/dismiss`);
}

export const editComment =(data, commentId) => {
    return apiClient.post(`admin/comment/status/${commentId}`, data);
}

export const getEventData = (limit, page, search) => {
    return apiClient.get(`admin/event/list?page=${page}&limit=${limit}&search=${search}`);
}

export const updateEvent = (data, eventId) => {
    return apiClient.put(`admin/event/${eventId}`, data);
}

export const deleteEvent = (eventId) => {
    return apiClient.delete(`admin/event/${eventId}`);
}
export const getSkill = (limit, page) => {
    return apiClient.get(`admin/skill/list?page=${page}&limit=${limit}`);
}

export const getAllSkill = () => {
    return apiClient.get("admin/skill");
}
export const addSkill = (data) => {
    return apiClient.post("admin/skill/add", data);
}

export const editSkill = (data, skillId) => {
    return apiClient.put(`admin/skill/${skillId}`, data);
}

export const deleteSkill = (skillId) => {
    return apiClient.delete(`admin/skill/${skillId}`);
}

export const getNotificationList = (limit, page, search) => {
    return apiClient.get(`admin/notification?page=${page}&limit=${limit}&search=${search}`);
}

export const addBroadcastNotification = (data) => {
    return apiClient.post(
        `admin/notification`, data
    );
}

export const editBroadcastNotification = (data, notificationId) => {
    return apiClient.patch(
        `admin/notification/${notificationId}`, data
    );
}

export const deleteBroadcastNotification = (notificationId) => {
    return apiClient.delete(
        `admin/notification/${notificationId}`
    );
}

export const getCategoryList = (limit, page, search) => {
    return apiClient.get(`admin/category?page=${page}&limit=${limit}&search=${search}`);
}

export const getAllCategoryList = () => {
    return apiClient.get(`admin/category/list`);
}

export const addCategoryList = (data) => {
    return apiClient.post(
        `admin/category`, data
    );
}

export const editCategoryList = (data, categoryId) => {
    return apiClient.patch(
        `admin/category/${categoryId}`, data
    );
}

export const deleteCategoryList = (categoryId) => {
    return apiClient.delete(
        `admin/category/${categoryId}`
    );
}
export const getActivityList = (limit, page, search) => {
    return apiClient.get(`admin/activity?page=${page}&limit=${limit}&search=${search}`);
}

export const getAllActivityList = () => {
    return apiClient.get(`admin/activity/all`);
}

export const addActivityList = (data) => {
    return apiClient.post(
        `admin/activity`, data
    );
}

export const editActivityList = (data, activityId) => {
    return apiClient.patch(
        `admin/activity/${activityId}`, data
    );
}

export const deleteActivityList = (activityId) => {
    return apiClient.delete(
        `admin/activity/${activityId}`
    );
}

export const getTicketList = (limit, page, search) => {
    return apiClient.get(`admin/ticket?page=${page}&limit=${limit}&search=${search}`);
}

export const ticketStatus = (data, ticketId) => {
    return apiClient.patch(
        `admin/ticket/${ticketId}`, data
    );
}

export const deleteTicket = (ticketId) => {
    return apiClient.delete(
        `admin/ticket/${ticketId}`
    );
}

export const getPrivacyPolicy = () => {
    return apiClient.get(`admin/policy`);
}

export const editPrivacyPolicy = (data, policyId) => {
    return apiClient.patch(`admin/policy/${policyId}`, data);
}

export const crewListing = (page, limit, search, category = '') => {
    return apiClient.get(`admin/crew/list?page=${page}&limit=${limit}&search=${search}&category=${category}`);
}

export const companyListing = (page, limit, search, role = '', eventDate = '', category = '', eventType = '') => {
    let url = `admin/company/list?page=${page}&limit=${limit}&search=${search}&role=${role}&category=${category}&eventDate=${eventDate}&eventType=${eventType}`;
    return apiClient.get(url);
}

export const updateEventRouteLinks = (eventId, routeLinks) => {
    return apiClient.patch(`admin/company/${eventId}/route-links`, { routeLinks });
}

export const getUserList = (id, type, page, limit, search = '') => {
    let url = `admin/user/list?id=${id}&type=${type}&page=${page}&limit=${limit}`;
    if (search) {
        url += `&search=${search}`;
    }
    return apiClient.get(url);
}

export const addMembers = (data) => {
    return apiClient.post('admin/add-members', data);
}

export const getAppVersionApi = () => {
    return apiClient.get('app-version');
}

export const appVersionApi = (data) => {
    return apiClient.post('app-version', data);
}